// ------------------------Working module below------------------------

// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuthStore } from "../store/authStore";

// export default function TwoFAVerify() {
//   const [otp, setOtp] = useState("");
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState(false);
//   const navigate = useNavigate();
//   const { refreshSession, setAuthenticated } = useAuthStore() as any;

//   async function handleVerify() {
//     setError("");
//     try {
//       const baseURL = process.env.NODE_ENV === 'production'
//         ? 'https://2.operacrm.com'
//         : 'https://2.operacrm.com';

//       const pendingSessionId = localStorage.getItem('pending_2fa_session');
//       const body: any = { code: otp };
//       if (pendingSessionId) {
//         body.session_id = pendingSessionId;
//       }

//       const res = await fetch(`${baseURL}/api/v1/user/verify_2fa`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         credentials: "include",
//         body: JSON.stringify(body),
//       });

//       const data = await res.json();
//       console.log("2FA verify response:", data);

//       const responseData = data.result || data;
//       const isSuccess = responseData.success || data.success;

//       if (isSuccess) {
//         setSuccess(true);

//         // ✅ Refresh the Odoo session (this updates auth store)
//         if (typeof refreshSession === "function") {
//           try {
//             await refreshSession(); // should call /web/session/get_session_info
//           } catch (e) {
//             console.warn("Session refresh failed:", e);
//           }
//         }

//         // ✅ Mark authenticated manually if needed
//         if (typeof setAuthenticated === "function") {
//           setAuthenticated(true);
//         }

//         localStorage.removeItem('pending_2fa_session');

//         // ✅ Navigate directly to dashboard
//         navigate("/dashboard", { replace: true });
//       } else {
//         const errorMsg = responseData.error || data.error;
//         setError(errorMsg || "Invalid code. Please try again.");
//       }
//     } catch (err: any) {
//       console.error("2FA verify error:", err);
//       setError(err.message || "Something went wrong.");
//     }
//   }

//   return (
//     <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
//       <div className="bg-white shadow-md rounded-xl p-8 w-full max-w-md text-center">
//         <h1 className="text-2xl font-bold mb-4">Two-Factor Verification</h1>
//         <p className="text-gray-600 mb-6">
//           Enter the 6-digit code from your authenticator app to continue.
//         </p>
//         <input
//           type="text"
//           maxLength={6}
//           value={otp}
//           onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
//           className="border p-3 rounded w-full text-center text-xl tracking-widest"
//           placeholder="Enter 6-digit code"
//         />
//         <button
//           onClick={handleVerify}
//           className="mt-4 bg-green-600 text-white px-6 py-3 rounded w-full hover:bg-green-700 transition-all"
//         >
//           Verify & Continue
//         </button>
//         {error && <p className="text-red-500 mt-3">{error}</p>}
//         {success && (
//           <p className="text-green-600 mt-3">Verification successful!</p>
//         )}
//       </div>
//     </div>
//   );
// }

// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";

// export default function TwoFAVerify() {
//   const [otp, setOtp] = useState("");
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   async function handleVerify() {
//     setError("");
//     setLoading(true);

//     try {
//       const res = await fetch("https://operacrm.com/web/session/validate_totp", {
//         method: "POST",
//         credentials: "include",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           jsonrpc: "2.0",
//           params: { totp: otp }
//         }),
//       });

//       const data = await res.json();
//       console.log("validate_totp result:", data);

//       // SUCCESS ✔
//       if (data.result && data.result.uid) {
//         localStorage.removeItem("2fa_pending");
//         navigate("/dashboard", { replace: true });
//         return;
//       }

//       setError("Invalid code. Please try again.");
//     } catch (err: any) {
//       setError(err.message || "Something went wrong.");
//     } finally {
//       setLoading(false);
//     }
//   }

//   return (
//     <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
//       <div className="bg-white shadow-md rounded-xl p-8 w-full max-w-md text-center">
//         <h1 className="text-2xl font-bold mb-4">Two-Factor Verification</h1>

//         <input
//           type="text"
//           maxLength={6}
//           value={otp}
//           onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
//           className="border p-3 rounded w-full text-center text-xl tracking-widest"
//           placeholder="Enter 6-digit code"
//         />

//         <button
//           onClick={handleVerify}
//           disabled={loading}
//           className="mt-4 bg-green-600 text-white px-6 py-3 rounded w-full hover:bg-green-700 transition-all"
//         >
//           {loading ? "Verifying..." : "Verify & Continue"}
//         </button>

//         {error && <p className="text-red-500 mt-3">{error}</p>}
//       </div>
//     </div>
//   );
// }

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import odooClient from "../services/odooClient";
import { useAuthStore } from "../store/authStore";

export default function Verify2FA() {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const setAuthenticated = useAuthStore((s) => s.setAuthenticated);

  const handleVerify = async () => {
    setLoading(true);
    setError("");

    try {
      const resp = await odooClient.verifyOTP(code);
      console.log("OTP RESP:", resp);

      // CORRECT validation
      const otpSuccess =
        resp?.result?.result?.success === true ||
        resp?.result?.success === true ||
        resp?.success === true;

      if (!otpSuccess) {
        setError(resp?.error || resp?.result?.error || "Invalid code");
        setLoading(false);
        return;
      }

      // Wait for Odoo to set session cookie
      await new Promise((r) => setTimeout(r, 400));
      // Poll session until UID appears
      await useAuthStore.getState().refreshSession({ poll: true });

      const info = await odooClient.refreshSessionInfo();
      console.log("REFRESH SESSION INFO:", info);

      if (info?.user) {
        odooClient.restoreCredentialsAfter2FA();
        useAuthStore.setState({
          isAuthenticated: true,
          user: {
            id: String(info.user.id),
            email: info.user.email,
            firstName: info.user.name.split(" ")[0],
            lastName: info.user.name.split(" ").slice(1).join(" "),
            role: info.user.is_admin ? "admin" : "user",
            gallery: "myself",
          },
        });
      }
      await useAuthStore.getState().fetchPermissionsIfNeeded();

      if (useAuthStore.getState().isAuthenticated) {
        // localStorage.removeItem("pending_2fa_login");
        // localStorage.removeItem("pending_2fa_pass");
        // localStorage.removeItem("pending_2fa_session");
        navigate("/dashboard", { replace: true });
      } else {
        setError("Session not created, try again");
      }
    } catch (err: any) {
      setError(err.message || "OTP error");
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4 text-center">Enter OTP</h2>
        <input
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          className="w-full border rounded px-3 py-2"
          placeholder="6-digit code"
        />
        {error && <p className="text-red-500 mt-2">{error}</p>}

        <button
          onClick={handleVerify}
          className="w-full mt-4 bg-blue-600 text-white rounded py-2"
          disabled={loading}
        >
          {loading ? "Verifying..." : "Verify OTP"}
        </button>
      </div>
    </div>
  );
}
